export const getActiveCheckautoListKey = 'getActiveCheckautoList';
export const getActivePlacementListKey = 'getActivePlacementList';
export const getActiveRentListKey = 'getActiveRentList';
export const getActivePartsListKey = 'getActivePartsList';
export const getActiveSellListKey = 'getActiveSellList';
export const getActiveServicesListKey = 'getActiveServicesList';
